import { Module } from '../module';
import { Controller } from './sp-proximity.controller';

Module.component('spProximity', {
    bindings: {bluetoothCode: '<'},
    controller: Controller,
    templateUrl: require('./sp-proximity.html'),
});



// WEBPACK FOOTER //
// ./src/modules/reverse-ajax/sp-proximity/sp-proximity.component.js